import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-lablel',
  templateUrl: './form-lablel.component.html',
  styleUrls: ['./form-lablel.component.sass']
})
export class FormLablelComponent {
  @Input() label: string;
}
